import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const SearchResultTitleContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
});

const SearchResultTitle = styled(Typography)({
    fontWeight: '500',
});

const SearchResultSubtitle = styled(Typography)({
    marginTop: '4px',
    display: 'inline-block',
});

const StyledChip = styled(Chip, {
    shouldForwardProp: (prop) => prop !== 'isDraft',
})(({ theme, isDraft }) => ({
    height: 20,
    fontSize: '0.75rem',
    fontWeight: 'bold',
    backgroundColor: isDraft ? '#fff3e0' : '#e8f5e9',
    color: isDraft ? '#e65100' : '#2e7d32',
    marginLeft: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
}));

const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'N/A';
        return date.toLocaleDateString();
    } catch (_e) {
        return 'N/A';
    }
};

const StatusChip = ({ status }) => {
    const text = status ? status.toUpperCase() : 'PUBLISHED';
    const isDraft = text === 'DRAFT';
    return <StyledChip label={text} size="small" isDraft={isDraft} />;
};

StatusChip.propTypes = {
    status: PropTypes.string,
};

const ContentSearchResultText = ({ item }) => (
    <>
        <SearchResultTitleContainer>
            <SearchResultTitle variant="body2">
                {item.title}
            </SearchResultTitle>
            <StatusChip status={item.status} />
        </SearchResultTitleContainer>
        <SearchResultSubtitle component="span" variant="caption" color="text.secondary">
            {item.type} | ID: {item.id} | Published: {formatDate(item.published_at)} | Expires: {formatDate(item.expired_at)}
        </SearchResultSubtitle>
    </>
);

ContentSearchResultText.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        status: PropTypes.string,
        published_at: PropTypes.string,
        expired_at: PropTypes.string,
    }).isRequired,
};

export { ContentSearchResultText, StatusChip, formatDate };
